import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ClipboardCheck, ArrowRight, Mail, CreditCard, Truck } from "lucide-react";
import ShopNav from "../../components/shop/ShopNav";
import { useCart } from "../../context/CartContext";
import { useI18n } from "../../context/I18nContext";

const ease = [0.16, 1, 0.3, 1];

export default function ShopSuccess() {
  const { t } = useI18n();
  const { clear } = useCart();
  const [params] = useSearchParams();
  const code = params.get("order");

  useEffect(() => { clear(); }, [clear]);

  const nextSteps = t("shop.success.next");

  return (
    <div className="min-h-screen bg-cream text-navy">
      <ShopNav />
      <div className="max-w-xl mx-auto px-6 py-20 text-center" data-testid="shop-success">
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease }}>
          <ClipboardCheck className="w-14 h-14 mx-auto text-emerald-500" />
          <h1 className="font-editorial text-4xl tracking-tight mt-5">{t("shop.success.title")}</h1>
          <p className="text-navy/60 mt-3">{t("shop.success.subtitle")}</p>
          {code && (
            <div className="mt-4 inline-block bg-white border border-navy/10 rounded-full px-5 py-2 text-sm" data-testid="shop-success-order">
              {t("shop.success.order")}: <span className="font-mono font-medium">#{code}</span>
            </div>
          )}
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease, delay: 0.1 }}
          className="mt-8 bg-white border border-navy/10 rounded-xl p-6 text-left">
          <div className="overline text-navy/40 mb-4">{t("shop.success.whatNext")}</div>
          <div className="space-y-4">
            {Array.isArray(nextSteps) && nextSteps.map((s, idx) => {
              const Icon = [Mail, CreditCard, Truck][idx] || Mail;
              return (
                <div key={idx} className="flex gap-3">
                  <div className="w-9 h-9 rounded-full bg-cream flex items-center justify-center shrink-0"><Icon className="w-4 h-4 text-violet" /></div>
                  <p className="text-sm text-navy/65 leading-relaxed pt-1.5">{s}</p>
                </div>
              );
            })}
          </div>
        </motion.div>

        <div className="flex items-center justify-center gap-3 mt-8">
          <Link to="/shop" className="inline-flex items-center gap-2 rounded-full bg-navy text-white px-6 py-3 hover:bg-navy-soft transition-colors">{t("shop.success.back")} <ArrowRight className="w-4 h-4" /></Link>
          <Link to="/shop/track" className="inline-flex items-center gap-2 rounded-full border border-navy/15 px-6 py-3 hover:border-violet hover:text-violet transition-colors">{t("shop.trackLink")}</Link>
        </div>
      </div>
    </div>
  );
}
